module.exports = __webpack_public_path__ + "static/media/star.db6b4396.svg";


//////////////////
// WEBPACK FOOTER
// ./src/game/bomber/star/star.svg
// module id = 45
// module chunks = 0